import css from "@styles/components/about/profile.module.scss";

export default function Profile() {
	return (
		<div className={css["profile-container"]}>
			<img className={css["profile-picture"]} src="/assets/images/misc/profile-picture.jpg" alt="Profile" />
		</div>
	);
}
